import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserManagementComponent } from './setting/user-management/user-management.component';
import { NoAuthComponent } from './pages/errors/no-auth/no-auth.component';
import { IndexComponent } from './pages/home/index/index.component';
import { HomePageComponent } from './pages/official-website/home-page/home-page.component';
import { HomePageBackupComponent } from './pages/official-website/home-page-backup/home-page-backup.component';
import { ServicesComponent } from './pages/official-website/services/services.component';
import { PartsComponent } from './pages/official-website/ecat/parts.component';
import { VideoPlayerComponent } from './pages/official-website/ecat/video/video-player.component';
import { ServiceTrainingComponent } from './pages/official-website/services/service-training/service-training.component';
import { EquipmentServicesComponent } from './pages/official-website/services/equipment-services/equipment-services.component';
import { EmptyNewPageComponent } from './pages/official-website/empty-new-page/empty-new-page.component';
import { NewsCenterComponent } from './pages/official-website/news-center/news-center.component';
import { NewsDetailComponent } from './pages/official-website/news-center/news-detail/news-detail.component';
import { DieselRepairNetworkComponent } from './pages/official-website/services/diesel-repair-network/diesel-repair-network.component';
import { BSSPartsSelectionComponent } from './pages/official-website/services/bss-parts-selection/bss-parts-selection.component';
import { CVPlanComponent } from './pages/official-website/services/cv-plan/cv-plan.component';
import { ExtraRewardsComponent } from './pages/official-website/services/extra-rewards/extra-rewards.component';
import { ContactUsComponent } from './pages/official-website/home-page/contact-us/contact-us.component';
import { OrderHistoryIndex } from './pages/order/index.component';
import { QuickAddComponent } from './pages/quick-add/quick-add.component';
import { OrderSuccessComponent } from './pages/order-success/order-success.component';
import { MyAccountComponent } from './pages/user-info/my-account/my-account.component';
import { DataPrivacyMessage } from './pages/user-info/data-privacy/data-privacy.component';
import { UserTermsMessage } from './pages/user-info/user-terms/user-terms.component';
import { MyAccountSoldToDetail } from './pages/user-info/sold-to-detail/sold-to-detail.component';
import { NotificationSettingComponent } from './pages/notification-setting/notification-setting.component';
import { OrganizationProfileComponent } from './pages/user-info/organization-profile/organization-profile.component';
import { OrderDetailComponent } from './pages/order/order-detail/order-detail.component';
import { ProductComponent } from './pages/product/product.component';
import { ProductVinSearchComponent } from './pages/product/mobile/vin-search/index.component';
import { ProductCompanySearchComponent } from './pages/product/mobile/company-search/index.component';
import { ProductVehicleSearchComponent } from './pages/product/mobile/vehicle-search/index.component';
import { ProductDetailComponent } from './pages/product/product-detail/product-detail.component';
import { OrderFailedComponent } from './pages/cart/order-failed/order-failed.component';
import { OrderInProcessComponent } from './pages/cart/order-in-process/order-in-process.component';
import { CartIndexComponent } from './pages/cart/index/index.component';
import { TargetAchievementComponent } from './pages/target-achievement/target-achievement.component';
import { RebateContractComponent } from './pages/rebate_contract/rebate-contract.component';
import { MarketingActivityComponent } from './pages/marketing-activity/marketing-activity.component';
import { PromotionActivityComponent } from './pages/promotion-activity/promotion-activity.component';
import { EcatMobileSearchComponent } from './pages/official-website/ecat/mobile/ecat-mobile-search/ecat-mobile-search.component';
import { EcatMobilePartListComponent } from './pages/official-website/ecat/mobile/ecat-mobile-part-list/ecat-mobile-part-list.component';
import { PartDetailMobileComponent } from './pages/official-website/ecat/part-detail/part-detail-mobile.component';
import { PartDetailComponent } from './pages/official-website/ecat/part-detail/part-detail.component';

// dealer-portal
import { DealerPortalHome } from './pages/dealerPortal/home/home.component';
// sales-portal
import { TurnoverComponent } from './pages/sales-portal/turnover/turnover.component';
import { TurnoverDetailComponent } from './pages/sales-portal/turnover/detail/turnover-detail.component';
import { TurnoverSettingComponent } from './pages/sales-portal/turnover/setting/turnover-setting.component';
import { WorkshopAcquisitionComponent } from './pages/sales-portal/workshop-acquisition/workshop-acquisition.component';
import { WorkshopAcquisitionDetailComponent } from './pages/sales-portal/workshop-acquisition/detail/workshop-acquisition-detail.component';
import { WorkshopAcquisitionSettingComponent } from './pages/sales-portal/workshop-acquisition/setting/workshop-acquisition-setting.component';
import { LoginComponent } from './pages/login/login.component';
// dealer-portal
import { ClaimComponent } from './pages/dealer-portal/claim/claim.component';
import { ClaimOverviewComponent } from './pages/claim/claim-overview/claim-overview.component';
import { CreateClaimComponent } from './pages/claim/create-claim/create-claim.component';
import { ClaimDetailComponent } from './pages/claim/claim-detail/claim-detail.component';
import { AuthGuard } from './guards/auth.guard';
import { DocumentsComponent } from './pages/documents/documents.component';
import { WiperIntroComponent } from './pages/wiper-intro-page/wiper-intro.component';
import { WorkShopComponent } from './pages/work-shop/work-shop.component';
// My Account
import { DataProtectionPolicyComponent } from './pages/user-info/data-protection-policy/index.component';
import { OrderTermsComponent } from './pages/user-info/order-terms/order-terms.component';
import { GettokenComponent } from './pages/login/gettoken/gettoken.component';
import { WarrantyComponent } from './pages/warranty/warranty.component';

function getConfigFromComponent() {
  if (window.location.pathname.startsWith('/Salesportal')) {
    return IndexComponent;
  } else {
    return HomePageComponent
  }
};

function hasPermission(title: string): boolean {
  const menuData = JSON.parse(localStorage.getItem('menu') || '[]');
  // only check childNote
  return menuData.some((menu: any) =>
    menu.childNode && checkChildNodes(menu.childNode, title)
  );
}

function checkChildNodes(childNodes: any[], title: string): boolean {
  return childNodes.some((child: any) =>
    child.url === title || (child.childNode && checkChildNodes(child.childNode, title))
  );
}
// get country value from localStorage
function getCountry(): string {
  const country = localStorage.getItem('country');
  return country ? country : 'iam'; // default 'iam'
}
const routes: Routes = [
  { path: '', redirectTo: `home/index`, pathMatch: 'full' },
  // {
  //   path: 'iam',
  //   redirectTo: `iam/home/index`,
  //   pathMatch: 'full',
  //   data: {
  //     breadcrumb: 'Home'
  //   }
  // },
  // { path: 'oes', redirectTo: `oes/home/index`, pathMatch: 'full' },
  {
    path: ':country/myAccount/data-protection-policy',
    component: DataProtectionPolicyComponent,
  },
  {
    path: ':country/myAccount/user-terms',
    component: UserTermsMessage,
    canActivate: [],
  },
  {
    path: 'gettoken', component: GettokenComponent,
  },
  {
    path: 'iam/cart/gettoken', component: GettokenComponent,
  },
  {
    path: ':country/order-terms',
    component: OrderTermsComponent
  },
  {
    path: ':country/myAccount/sold-to-detail',
    component: MyAccountSoldToDetail
  },
  {
    path: ':country/order/history',
    component: OrderHistoryIndex,
    data: { reuse: true, requiresAuthCheck: true },
    canActivate: [AuthGuard],
  },
  {
    path: ':country/contracts_rebates',
    component: RebateContractComponent,
    canActivate: [AuthGuard],
  },
  {
    path: ':country/marketing-activity',
    component: MarketingActivityComponent,
    canActivate: [AuthGuard],
  },
  {
    path: ':country/promotion-activity',
    component: PromotionActivityComponent,
    canActivate: [AuthGuard],
  },
  {
    path: ':country/order/detail',
    component: OrderDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: ':country/order/failed',
    component: OrderFailedComponent,
    canActivate: [AuthGuard],
  },
  {
    path: ':country/notification/setting',
    component: NotificationSettingComponent,
    canActivate: [AuthGuard],
  },
  {
    path: ':country/user/my-account',
    component: MyAccountComponent,
    canActivate: [AuthGuard],
  },
  {
    path: ':country/user/data-privacy',
    component: DataPrivacyMessage
  },
  {
    path: ':country/user/user-terms',
    component: UserTermsMessage
  },
  {
    path: ':country/user/organization',
    component: OrganizationProfileComponent,
    canActivate: [AuthGuard],
  },
  {
    path: ':country/home/index',
    component: getConfigFromComponent(),
    canActivate: [AuthGuard],
  },
  {
    path: ':country/home-bak/index',
    component: getConfigFromComponent(),
    canActivate: [AuthGuard],
  },
  {
    path: 'home/index',
    component: getConfigFromComponent(),
    data: {
      title: 'Home'
    }
  },
  {
    path: 'gb/cn',
    component: HomePageComponent,
    data: {
      title: 'HomePage'
    }
  },
  {
    path: 'gb/cn/homepage',
    component: HomePageBackupComponent,
    data: {
      title: 'HomePageBackup'
    }
  },
  {
    path: ':country/gb/cn/product/wiper/smartfit-pro',
    component: WiperIntroComponent,
    data: {
      title: 'Wiper Intro'
    }
  },
  {
    path: 'gb/cn/product/wiper/smartfit-pro',
    component: WiperIntroComponent,
    data: {
      title: 'Wiper Intro'
    }
  },
  {
    path: 'gb/cn/contact',
    component: ContactUsComponent,
    data: {
      title: 'Contact Us'
    }
  },
  {
    path: 'gb/cn/services',
    component: ServicesComponent,
    data: {
      title: 'Services'
    }
  },
  {
    path: 'gb/cn/parts',
    component: PartsComponent,
    data: {
      title: 'Parts'
    }
  },
  {
    path: 'gb/cn/product/:category/:subcategory/:type/:attachmentId',
    component: VideoPlayerComponent,
    data: {
      title: 'Video Player'
    }
  },
  {
    path: 'gb/cn/parts/ecat-search',
    component: EcatMobileSearchComponent,
    data: {
      title: 'Parts'
    }
  },
  {
    path: 'gb/cn/parts/ecat-part-list',
    component: EcatMobilePartListComponent,
    data: {
      title: 'Parts'
    }
  },
  {
    path: 'gb/cn/parts/part-detail/:partId',
    component: PartDetailMobileComponent,
    data: {
      title: 'Parts'
    }
  },
  {
    path: 'gb/cn/parts/pc-part-detail/:partId',
    component: PartDetailComponent,
    data: {
      title: 'Parts'
    }
  },
  {
    path: 'gb/cn/parts/ecat-part-list/searchByVin/:vinCode',
    component: EcatMobilePartListComponent,
    data: {
      title: 'Parts'
    }
  },
  {
    path: 'gb/cn/documents',
    component: DocumentsComponent,
    data: { title: 'Documents' },
  },
  {
    path: 'gb/cn/services/training-solutions/service-training',
    component: ServiceTrainingComponent,
    data: {
      title: 'Service Training'
    }
  },
  {
    path: 'gb/cn/services/service-solutions/equipment-services',
    component: EquipmentServicesComponent,
    data: {
      title: 'Equipment Services'
    }
  },
  {
    path: 'gb/cn/services/workshop-concepts/bosch-diesel-repair-network',
    component: DieselRepairNetworkComponent,
    data: {
      title: 'Bosch Diesel Repair Network'
    }
  },
  {
    path: 'gb/cn/services/workshop-concepts/bss-parts-selection-store',
    component: BSSPartsSelectionComponent,
    data: {
      title: 'BSS Parts Selection Store'
    }
  },
  {
    path: 'gb/cn/services/workshop-concepts/cv-plan',
    component: CVPlanComponent,
    data: {
      title: 'CV Plan'
    }
  },
  {
    path: 'gb/cn/services/programs/extra-rewards',
    component: ExtraRewardsComponent,
    data: {
      title: 'Extra Rewards'
    }
  },
  {
    path: 'gb/cn/news/:id',
    component: NewsDetailComponent,
    data: {
      title: '新闻详情'
    }
  },
  {
    path: 'gb/cn/news',
    component: NewsCenterComponent,
    data: {
      title: '新闻中心'
    }
  },
  {
    path: ':country/gb/cn/news/:id',
    component: NewsDetailComponent,
    data: {
      title: '新闻详情'
    }
  },
  {
    path: ':country/gb/cn/news',
    component: NewsCenterComponent,
    data: {
      title: '新闻中心'
    }
  },
  {
    path: 'gb/cn/new-page',
    component: EmptyNewPageComponent,
    data: {
      title: 'New Page'
    }
  },
  {
    path: ':country/gb/cn/services',
    component: ServicesComponent,
    data: {
      title: 'Services'
    }
  },
  {
    path: ':country/gb/cn/homepage',
    component: HomePageBackupComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'HomePageBackup'
    }
  },
  {
    path: ':country/homepage',
    component: HomePageBackupComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'HomePageBackup'
    }
  },
  {
    path: ':country/gb/cn/services/training-solutions/service-training',
    component: ServiceTrainingComponent,
    data: {
      title: 'Service Training'
    }
  },
  {
    path: ':country/gb/cn/services/service-solutions/equipment-services',
    component: EquipmentServicesComponent,
    data: {
      title: 'Equipment Services'
    }
  },
  {
    path: ':country/gb/cn/services/workshop-concepts/bosch-diesel-repair-network',
    component: DieselRepairNetworkComponent,
    data: {
      title: 'Bosch Diesel Repair Network'
    }
  },
  {
    path: ':country/gb/cn/services/workshop-concepts/bss-parts-selection-store',
    component: BSSPartsSelectionComponent,
    data: {
      title: 'BSS Parts Selection Store'
    }
  },
  {
    path: ':country/gb/cn/services/workshop-concepts/cv-plan',
    component: CVPlanComponent,
    data: {
      title: 'CV Plan'
    }
  },
  {
    path: ':country/gb/cn/services/programs/extra-rewards',
    component: ExtraRewardsComponent,
    data: {
      title: 'Extra Rewards'
    }
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: ':country/ecatalog',
    component: ProductComponent,
    data: { reuse: true },
    canActivate: [AuthGuard],
  },
  {
    path: ':country/mobile/vin-search',
    component: ProductVinSearchComponent,
    // data: { reuse: true },
    // canActivate: [AuthGuard],
  },
  {
    path: ':country/mobile/company-search',
    component: ProductCompanySearchComponent,
    // data: { reuse: true },
    // canActivate: [AuthGuard],
  },
  {
    path: ':country/mobile/vehicle-search',
    component: ProductVehicleSearchComponent,
    // data: { reuse: true },
    // canActivate: [AuthGuard],
  },
  {
    path: 'ecatalog',
    component: ProductComponent,
    data: { reuse: true, readcrumb: 'Home' },
  },
  {
    path: 'documents',
    component: DocumentsComponent,
    data: { reuse: true, readcrumb: 'Home' },
  },
  {
    path: ':country/target-achievement',
    component: TargetAchievementComponent,
    canActivate: [AuthGuard],
  },
  {
    path: ':country/work-shop',
    component: WorkShopComponent,
    data: {
      title: 'Work Shop'
    }
  },
  {
    path: ':country/documents',
    component: DocumentsComponent,
    data: { reuse: true },
    canActivate: [AuthGuard],
  },
  {
    path: 'product/detail',
    component: ProductDetailComponent
  },
  {
    path: ':country/product/detail',
    component: ProductDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: ':country/quick-add',
    component: QuickAddComponent,
    canActivate: [AuthGuard],
    data: { requiresAuthCheck: true },
  },

  {
    path: ':country/order-success',
    component: OrderSuccessComponent,
    canActivate: [AuthGuard],
  },
  {
    path: ':country/order-in-progress',
    component: OrderInProcessComponent,
    canActivate: [AuthGuard],
  },
  {
    path: ':country/cart',
    component: CartIndexComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'personnel/user',
    component: UserManagementComponent,
  },
  {
    path: 'sales-portal/turnover',
    component: TurnoverComponent,
  },
  {
    path: 'sales-portal/turnover/detail',
    component: TurnoverDetailComponent,
  },
  {
    path: 'sales-portal/turnover/setting',
    component: TurnoverSettingComponent,
  },
  {
    path: 'sales-portal/workshop-acquisition',
    component: WorkshopAcquisitionComponent,
  },
  {
    path: 'sales-portal/workshop-acquisition/detail',
    component: WorkshopAcquisitionDetailComponent,
  },
  {
    path: 'sales-portal/workshop-acquisition/setting',
    component: WorkshopAcquisitionSettingComponent,
  },
  {
    path: ':country/dealer-portal-claim',
    component: ClaimComponent,
  },
  {
    path: ':country/claim',
    component: ClaimOverviewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: ':country/claim/create',
    component: CreateClaimComponent,
    canActivate: [AuthGuard],
  },
  {
    path: ':country/claim/edit/:id',
    component: CreateClaimComponent,
    canActivate: [AuthGuard],
  },
  {
    path: ':country/claim/detail/:id',
    component: ClaimDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'warranty',
    component: WarrantyComponent,
  },
  {
    path: ':country/warranty',
    component: WarrantyComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'no-auth',
    component: NoAuthComponent,
  },
  {
    path: '**',
    component: NoAuthComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
